import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotRocketComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotRocket',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1FDC81",
    d: "m11.453 20.496-6.157-5.168 4.993-5.95c3.87-4.747 6.893-6.323 10.566-8.102.948-.46 2.017.44 1.721 1.45-1.185 4.049-2.376 7.56-6.131 11.825l-4.992 5.945Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#02AF5C",
    fillRule: "evenodd",
    d: "m4.515 14.673.78.655 2.743-3.275A22.385 22.385 0 0 0 11.38 6.82c.293-.67-.469-1.31-1.078-.904a22.38 22.38 0 0 0-4.574 4.2l-1.46 1.74a2 2 0 0 0 .247 2.818Zm7.717 6.478a2 2 0 0 0 2.817-.247l1.462-1.742a22.35 22.35 0 0 0 3.341-5.234c.293-.67-.468-1.309-1.076-.904A22.415 22.415 0 0 0 14.2 17.22l-2.75 3.275.782.656Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1FDC81",
    d: "M3.955 23.145s-1.166-2.184.093-3.56c1.233-1.347 2.515-.249 3.373-.936a1.412 1.412 0 0 0 .5-1.116s1.212 2.22-.078 3.546c-1.315 1.35-2.6.38-3.33.946a1.227 1.227 0 0 0-.558 1.12Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#028C4A",
    d: "M15.717 9.996a1.58 1.58 0 1 0 .818-3.051 1.58 1.58 0 0 0-.818 3.05Z"
  }));
};
SpotRocketComponent.displayName = 'SpotRocket';
export var SpotRocket = withProvisionalOverrideFromContext(SpotRocketComponent);
//# sourceMappingURL=index.js.map